import { connect } from 'react-redux';
import * as selectors from 'selectors';
import Modal from 'comp/modals/block_list';

const mapToProps = state => {
  const selected_id = selectors.getSelectedConvId();
  return {
    block_list: selectors.nullInPath(state, 'conv', selected_id, 'members'),
    selected_id,
    user_id: state.user.id
  };
};

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/BlockList.js